/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Operator_LabelInputs */

const fr_vehicle_action_edit_operator_label = /** @type {(inputs: Vehicle_Action_Edit_Operator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opérateur`)
};

const en_vehicle_action_edit_operator_label = /** @type {(inputs: Vehicle_Action_Edit_Operator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operator`)
};

/**
* | output |
* | --- |
* | "Operator" |
*
* @param {Vehicle_Action_Edit_Operator_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_operator_label = /** @type {((inputs?: Vehicle_Action_Edit_Operator_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Operator_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_operator_label(inputs)
	return en_vehicle_action_edit_operator_label(inputs)
});